<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { EvalModelClonerViewModel } from '@Evaluation/EvaluationModels/Components/EvalModelCloner';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class EvalModelCloner extends Vue
    {
        get vm(): EvalModelClonerViewModel { return this.$props.viewModel as EvalModelClonerViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }
        get operationInProgress(): boolean { return this.vm.operationInProgress; }
        get cloneFailed(): boolean { return this.vm.cloneFailed; }
        get cloneError(): string | null { return this.vm.errors.find(e => e.ErrorCode.startsWith("Export."))?.Error ?? null; }
        get goalError(): string | null { return this.vm.errors.find(e => !e.ErrorCode.startsWith("Export."))?.Error ?? null; }

        get cloneName(): string | null { return this.vm.name; }
        set cloneName(val: string | null) { this.vm.name = val; }

        handleFormSubmit()
        {
            this.vm.operationInProgress = true;
            this.vm.clearValidationErrors();
            this.$emit("clone-evalmodel", this.vm.sourceId, this.cloneName);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Clone</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="evalmodel-cloner-form" @submit.prevent="handleFormSubmit">
                            <div class="alert alert-danger" v-if="cloneFailed">
                                <p>Clone failed. Sorry, something went wrong :(</p>
                                <small>{{cloneError}}</small>
                            </div>
                            <div class="form-group">
                                <label>Clone name:</label>
                                <input v-model.trim="cloneName" type="text" class="form-control">
                                <small class="text-danger">{{goalError}}</small>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="evalmodel-cloner-form" :disabled="operationInProgress" class="btn btn-primary">
                            <span v-if="operationInProgress"><i class="fa fa-spinner fa-spin"></i> Please wait...</span>
                            <span v-if="!operationInProgress">Clone</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>